import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import paths from "routes/paths";
import PromotionRail from "./PromotionRail";
import "./SidePromotionSection.css";

const sidePromotionItems = (navigate) => [
  {
    eyebrow: "Sponsored",
    slotLabel: "Ad space",
    placeholder: true,
    icon: "rocket",
    pinned: true,
  },
  {
    eyebrow: "Profile strength",
    title: "Keep your profile current",
    titleLevel: 5,
    description: "Refresh skills, documents, and availability before the next review.",
    actionLabel: "Improve profile",
    featured: true,
    icon: "profile",
    onAction: () => navigate(paths.professionalProfiles),
  },
  {
    eyebrow: "Background checks",
    title: "Be ready to start faster",
    titleLevel: 5,
    description: "Eligible checks can reduce delays once a team moves forward.",
    actionLabel: "Request background check",
    actionLabelLines: ["Request", "background check"],
    icon: "backgroundCheck",
    onAction: () => navigate(paths.backgroundChecks),
  },
  {
    eyebrow: "Hiring flow",
    title: "Stay ready for next steps",
    titleLevel: 5,
    description: "Track applications, interviews, invitations, and hiring notes together.",
    icon: "hiring",
  },
];

const SidePromotionSection = ({
  className = "",
  items,
  visibleCount = 3,
  intervalMs = 9000,
  showControls = true,
}) => {
  const navigate = useNavigate();
  const defaultItems = useMemo(() => sidePromotionItems(navigate), [navigate]);

  return (
    <PromotionRail
      className={["side-promotion-section", className].filter(Boolean).join(" ")}
      items={items || defaultItems}
      rotating
      showControls={showControls}
      intervalMs={intervalMs}
      visibleCount={visibleCount}
    />
  );
};

export default SidePromotionSection;
